module.exports = __webpack_public_path__ + "img/14.6b3d5fb0.png";